import { apiClient } from './client';
import { CurrentUser, UserProfile } from '../types/auth';

export interface LoginResponse {
  accessToken: string;
  user: UserProfile;
}

export const loginRequest = async (email: string, password: string): Promise<LoginResponse> => {
  const { data } = await apiClient.post('/auth/login', { email, password });
  return data.data;
};

export const refreshRequest = async (): Promise<LoginResponse> => {
  const { data } = await apiClient.post('/auth/refresh');
  return data.data;
};

export const logoutRequest = async (): Promise<void> => {
  await apiClient.post('/auth/logout');
};

export const meRequest = async (): Promise<CurrentUser> => {
  const { data } = await apiClient.get('/auth/me');
  return data.data;
};

export const forgotPasswordRequest = async (email: string): Promise<void> => {
  await apiClient.post('/auth/forgot-password', { email });
};

export const resetPasswordRequest = async (token: string, newPassword: string): Promise<void> => {
  await apiClient.post('/auth/reset-password', { token, newPassword });
};

export const changePasswordRequest = async (
  currentPassword: string,
  newPassword: string,
): Promise<void> => {
  await apiClient.post('/auth/change-password', { currentPassword, newPassword });
};
